<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      User Ledger
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="4">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              @input="menu2 = false"
              @click:date="dateSelect"
              :max="nowDate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
      ></v-text-field>
    </v-card-title>
    <v-col cols="12">
      Total Ledger Amount:<v-chip>{{ total_ledger_amount }}</v-chip>
      Paid: <v-chip color="success">{{ total_paid_amount }}</v-chip>
      Due: <v-chip color="red">{{ total_due_amount }}</v-chip>
    </v-col>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-1"
          :search="search"
          dense
          :loading="loadingstatus"
          mobile-breakpoint="0"
          :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="userCollectAmountHistory(item.id)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  color="orange"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-pencil</v-icon>
              </v-chip>
            </template>
            <span>User Collect Amount</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="user_ledger_new(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="orange"
                  label
                  outlined
                  small
              ><v-icon left> mdi-motorbike </v-icon>
                >>
              </v-chip>
            </template>
            <span>New User Ledger</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="add_user_collect_amount_history_dialog" max-width="720" scrollable>
      <v-card>
        <v-card-title class="headline">
          Collect Amount for {{ date }}
          <div class="subtitle-2 mt-1">Payment By <b>{{ user_name }}</b></div>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="4">
              <span><b>Ledger Amount:</b> {{ formatAmount(ledger_amount) }}</span>
            </v-col>
            <v-col cols="12" sm="4">
              <span><b>Already Paid:</b> {{ formatAmount(alreadyPaidAmount) }}</span>
            </v-col>
            <v-col cols="12" sm="4">
              <span><b>Due:</b> {{ formatAmount(due_amount) }}</span>
            </v-col>
          </v-row>

          <v-divider class="my-3"></v-divider>
          <p class="subtitle-2 mb-1">Settlement</p>
          <v-row dense>
            <v-col cols="12" sm="6" v-if="settlementChecks.void_cancel.amount > 0">
              <v-checkbox
                  v-model="settlementChecks.void_cancel.checked"
                  hide-details
                  dense
                  :label="'Void/Cancel — ' + formatAmount(settlementChecks.void_cancel.amount)"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" v-if="settlementChecks.refund_to_patient.amount > 0">
              <v-checkbox
                  v-model="settlementChecks.refund_to_patient.checked"
                  hide-details
                  dense
                  :label="'Refund to Patient — ' + formatAmount(settlementChecks.refund_to_patient.amount)"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" v-if="settlementChecks.doctor_payment.amount > 0">
              <v-checkbox
                  v-model="settlementChecks.doctor_payment.checked"
                  hide-details
                  dense
                  :label="'Doctor Payment — ' + formatAmount(settlementChecks.doctor_payment.amount)"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" v-if="settlementChecks.cashback.amount > 0">
              <v-checkbox
                  v-model="settlementChecks.cashback.checked"
                  hide-details
                  dense
                  :label="'Cashback — ' + formatAmount(settlementChecks.cashback.amount)"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-divider class="my-3"></v-divider>
          <p class="subtitle-2 mb-1">Payment Method (payment_method field)</p>
          <v-row dense v-if="paymentMethodChecks.length">
            <v-col cols="12" sm="6" v-for="(pm, index) in paymentMethodChecks" :key="'pm-' + index">
              <v-checkbox
                  v-model="pm.checked"
                  hide-details
                  dense
                  :label="pm.method + ' — ' + formatAmount(pm.amount)"
              ></v-checkbox>
            </v-col>
          </v-row>
          <p v-else class="caption grey--text">No payment method data for this date.</p>

          <v-divider class="my-3"></v-divider>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                  v-model="paymentDataSubmit.paid_amount"
                  outlined
                  dense
                  type="number"
                  min="0"
                  step="0.01"
                  :max="due_amount"
                  label="Receive Amount From PRO"
                  :error-messages="paidAmountError"
                  hide-details="auto"
                  @input="paidAmountError = null"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="paymentDataSubmit.note"
                  outlined
                  dense
                  label="Note"
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <small><i>*ইউজার যদি ওভার পেমেন্ট করতে চায়, তাহলে বাকিটা সফটওয়্যার ছাড়া সংগ্রহ করতে হবে।</i></small>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-if="spinnerButtons">
            <v-progress-circular :width="12" size="61" color="green" indeterminate></v-progress-circular>
          </div>
          <template v-else>
            <v-btn text @click="closeCollectDialog">Cancel</v-btn>
            <v-btn color="primary" @click="user_payment_history_submit">Submit</v-btn>
          </template>
        </v-card-actions>
        <p class="subtitle-2 px-4 pt-2 mb-0">Collection History</p>
        <v-data-table
            :headers="user_collect_histories_headers"
            :items="user_collect_histories"
            class="elevation-0 px-4 pb-4"
            dense
        >
          <template v-slot:item.paid_amount="{ item }">
            {{ formatAmount(item.paid_amount) }}
          </template>
          <template v-slot:item.total_received_amount="{ item }">
            {{ formatAmount(item.total_received_amount) }}
          </template>
          <template v-slot:item.created_at="{ item }">
            {{ formatDateTime(item.created_at) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon small color="primary" @click="openCollectDetailsModal(item)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog v-model="collect_details_dialog" max-width="560" scrollable>
      <v-card>
        <v-card-title class="headline">
          Collection Details
          <div class="subtitle-2 mt-1" v-if="selectedHistoryRow">
            {{ formatDateTime(selectedHistoryRow.created_at) }}
            · Received by {{ selectedHistoryRow.received_by_user ? selectedHistoryRow.received_by_user.full_name : '—' }}
          </div>
        </v-card-title>
        <v-card-text v-if="parsedCollectDetails">
          <v-row dense class="mb-2">
            <v-col cols="6"><b>Paid Amount:</b> {{ formatAmount(selectedHistoryRow.paid_amount) }}</v-col>
            <v-col cols="6"><b>Today Collection:</b> {{ formatAmount(parsedCollectDetails.today_collection || parsedCollectDetails.total_received_amount) }}</v-col>
          </v-row>
          <v-alert v-if="parsedCollectDetails.calculation_summary" dense outlined type="info" class="mb-2">
            <div><b>Collection:</b> {{ formatAmount(parsedCollectDetails.calculation_summary.collection) }}</div>
            <div><b>Settlement:</b> {{ formatAmount(parsedCollectDetails.calculation_summary.settlement) }}</div>
            <div><b>Ledger Amount:</b> {{ formatAmount(parsedCollectDetails.calculation_summary.ledger_amount) }}</div>
            <div><b>Already Paid (before this entry):</b> {{ formatAmount(parsedCollectDetails.already_paid_before != null ? parsedCollectDetails.already_paid_before : parsedCollectDetails.calculation_summary.already_paid) }}</div>
            <div><b>This Payment:</b> {{ formatAmount(parsedCollectDetails.paid_this_time != null ? parsedCollectDetails.paid_this_time : selectedHistoryRow.paid_amount) }}</div>
            <div><b>Due (after this entry):</b> {{ formatAmount(detailsDueAfterEntry) }}</div>
            <v-divider class="my-2"></v-divider>
            <div class="caption grey--text mb-1">Live totals (all entries today)</div>
            <div class="success--text"><b>Total collected today:</b> {{ formatAmount(detailsCurrentTotalPaid) }}</div>
            <div><b>Due remaining now:</b> {{ formatAmount(detailsCurrentDue) }}</div>
          </v-alert>
          <v-divider class="my-2"></v-divider>
          <p class="subtitle-2 mb-1">Settlement</p>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
              <tr v-for="row in settlementDetailRows" :key="row.label">
                <td>{{ row.label }}</td>
                <td class="text-right">{{ formatAmount(row.amount) }}</td>
                <td class="text-right">
                  <v-chip x-small :color="row.checked ? 'success' : 'grey'" dark>
                    {{ row.checked ? 'Confirmed' : '—' }}
                  </v-chip>
                </td>
              </tr>
              <tr v-if="!settlementDetailRows.length">
                <td colspan="3" class="caption">No settlement data</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider class="my-3"></v-divider>
          <p class="subtitle-2 mb-1">Payment Methods</p>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
              <tr v-for="(pm, idx) in paymentMethodDetailRows" :key="'detail-pm-' + idx">
                <td>{{ pm.method }}</td>
                <td class="text-right">{{ formatAmount(pm.amount) }}</td>
                <td class="text-right">
                  <v-chip x-small :color="pm.checked ? 'success' : 'grey'" dark>
                    {{ pm.checked ? 'Confirmed' : '—' }}
                  </v-chip>
                </td>
              </tr>
              <tr v-if="!paymentMethodDetailRows.length">
                <td colspan="3" class="caption">No payment method data</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider class="my-3" v-if="selectedHistoryRow && selectedHistoryRow.note"></v-divider>
          <p v-if="selectedHistoryRow && selectedHistoryRow.note" class="caption mb-0"><b>Note:</b> {{ selectedHistoryRow.note }}</p>
        </v-card-text>
        <v-card-text v-else>
          <p class="caption mb-0">No collection details saved for this record.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="collect_details_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      spinnerButtons: false,
      date: moment().format('YYYY-MM-DD'),
      nowDate: moment().format('YYYY-MM-DD'),
      menu2: false,
      loadingstatus: true,
      total_ledger_amount: 0,
      total_paid_amount: 0,
      total_due_amount: 0,
      add_user_collect_amount_history_dialog: false,
      collectFormError: null,
      paidAmountError: null,
      headers: [
        { text: "Name", value: "full_name" },
        { text: "Ledger Amount", value: "ledger_amount" },
        { text: "Paid Amount", value: "paid_amount" },
        { text: "Due Amount", value: "due_amount" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      user_collect_histories_headers: [
        { text: "Paid Amount", value: "paid_amount" },
        { text: "Total Collection", value: "total_received_amount" },
        { text: "Received By", value: "received_by_user.full_name" },
        { text: "Created at", value: "created_at" },
        { text: "Details", value: "actions", sortable: false },
      ],
      user_collect_histories: [],
      collect_details_dialog: false,
      selectedHistoryRow: null,
      parsedCollectDetails: null,
      items: [
        { text: "Dashboard", disabled: false, href: "/" },
        { text: "Users & Roles", disabled: true, href: "/" },
        { text: "User Ledger", disabled: true, href: "/" },
      ],
      user_name: '',
      ledger_amount: 0,
      today_collection: 0,
      today_settlement: 0,
      due_amount: 0,
      alreadyPaidAmount: 0,
      settlementChecks: {
        void_cancel: { amount: 0, checked: false },
        refund_to_patient: { amount: 0, checked: false },
        doctor_payment: { amount: 0, checked: false },
        cashback: { amount: 0, checked: false },
      },
      paymentMethodChecks: [],
      paymentDataSubmit: {
        date: '',
        paid_amount: '',
        note: '',
        payment_by_user_id: '',
        received_by_user_id: localStorage.getItem("userId"),
        collect_details: null,
      },
      apiBaseUrl: atshq.defaults.headers.common.api_base_URL,
      login_user_id: localStorage.getItem("userId"),
    };
  },
  created() {
    this.initialize(this.date);
  },
  computed: {
    today_ledger_calc() {
      return Math.round((this.today_collection - this.today_settlement) * 100) / 100;
    },
    settlementDetailRows() {
      if (!this.parsedCollectDetails) {
        return [];
      }
      const d = this.parsedCollectDetails;
      const rows = [
        { label: 'Void/Cancel', key: 'void_cancel' },
        { label: 'Refund to Patient', key: 'refund_to_patient' },
        { label: 'Doctor Payment', key: 'doctor_payment' },
        { label: 'Cashback', key: 'cashback' },
      ];
      return rows
          .map((row) => {
            const item = d[row.key] || {};
            return {
              label: row.label,
              amount: parseFloat(item.amount) || 0,
              checked: !!item.checked,
            };
          })
          .filter((row) => row.amount > 0 || row.checked);
    },
    paymentMethodDetailRows() {
      if (!this.parsedCollectDetails || !this.parsedCollectDetails.payment_methods) {
        return [];
      }
      return this.parsedCollectDetails.payment_methods.map((pm) => ({
        method: pm.method || 'Unknown',
        amount: parseFloat(pm.amount) || 0,
        checked: !!pm.checked,
      }));
    },
    detailsLedgerAmount() {
      if (this.parsedCollectDetails && this.parsedCollectDetails.calculation_summary) {
        return parseFloat(this.parsedCollectDetails.calculation_summary.ledger_amount) || 0;
      }
      return parseFloat(this.ledger_amount) || 0;
    },
    detailsCurrentTotalPaid() {
      return this.user_collect_histories.reduce((sum, row) => sum + (parseFloat(row.paid_amount) || 0), 0);
    },
    detailsCurrentDue() {
      return Math.max(0, this.detailsLedgerAmount - this.detailsCurrentTotalPaid);
    },
    detailsDueAfterEntry() {
      const d = this.parsedCollectDetails;
      if (!d) {
        return 0;
      }
      if (d.due_after != null && d.due_after !== '') {
        return parseFloat(d.due_after) || 0;
      }
      const ledger = this.detailsLedgerAmount;
      const before = parseFloat(
          d.already_paid_before != null ? d.already_paid_before : (d.calculation_summary && d.calculation_summary.already_paid)
      ) || 0;
      const paid = parseFloat(
          d.paid_this_time != null ? d.paid_this_time : (this.selectedHistoryRow && this.selectedHistoryRow.paid_amount)
      ) || 0;
      return Math.max(0, ledger - before - paid);
    },
  },
  methods: {
    formatAmount(value) {
      const num = parseFloat(value) || 0;
      return num.toFixed(2);
    },
    resetCollectForm() {
      this.collectFormError = null;
      this.paidAmountError = null;
      this.settlementChecks = {
        void_cancel: { amount: 0, checked: false },
        refund_to_patient: { amount: 0, checked: false },
        doctor_payment: { amount: 0, checked: false },
        cashback: { amount: 0, checked: false },
      };
      this.today_collection = 0;
      this.today_settlement = 0;
      this.paymentMethodChecks = [];
      this.paymentDataSubmit.paid_amount = '';
      this.paymentDataSubmit.note = '';
      this.paymentDataSubmit.collect_details = null;
    },
    closeCollectDialog() {
      this.add_user_collect_amount_history_dialog = false;
      this.resetCollectForm();
    },
    loadCollectBreakdown(data) {
      this.ledger_amount = parseFloat(data.ledger_amount) || 0;
      this.alreadyPaidAmount = parseFloat(data.alreadyPaidAmount) || 0;
      this.due_amount = parseFloat(data.due_amount) || 0;
      this.today_collection = parseFloat(data.total_received_amount) || 0;
      this.today_settlement =
          (parseFloat(data.void_cancel) || 0) +
          (parseFloat(data.refund_to_patient) || 0) +
          (parseFloat(data.doctor_payment) || 0) +
          (parseFloat(data.cashback) || 0);
      this.settlementChecks = {
        void_cancel: { amount: parseFloat(data.void_cancel) || 0, checked: false },
        refund_to_patient: { amount: parseFloat(data.refund_to_patient) || 0, checked: false },
        doctor_payment: { amount: parseFloat(data.doctor_payment) || 0, checked: false },
        cashback: { amount: parseFloat(data.cashback) || 0, checked: false },
      };
      this.paymentMethodChecks = (data.payment_methods || []).map((pm) => ({
        method: pm.method || 'Unknown',
        amount: parseFloat(pm.amount) || 0,
        checked: false,
      }));
    },
    showValidationError(message, field) {
      if (field === 'paid_amount') {
        this.paidAmountError = message;
      } else {
        this.collectFormError = message;
      }
      if (this.$noty) {
        this.$noty.error(message);
      }
    },
    buildCollectDetailsPayload() {
      const paymentMethodTotal = this.paymentMethodChecks.reduce((s, pm) => s + (parseFloat(pm.amount) || 0), 0);
      const paidThisTime = parseFloat(this.paymentDataSubmit.paid_amount) || 0;
      const alreadyPaidBefore = parseFloat(this.alreadyPaidAmount) || 0;
      return {
        report_date: this.date,
        today_collection: this.today_collection,
        total_received_amount: this.today_collection,
        today_settlement: this.today_settlement,
        ledger_amount: this.ledger_amount,
        already_paid_before: alreadyPaidBefore,
        paid_this_time: paidThisTime,
        due_after: this.ledger_amount - alreadyPaidBefore - paidThisTime,
        calculation_summary: {
          collection: this.today_collection,
          settlement: this.today_settlement,
          ledger_calc: this.today_ledger_calc,
          payment_method_total: paymentMethodTotal,
          ledger_amount: this.ledger_amount,
          already_paid: alreadyPaidBefore,
          due_before: this.due_amount,
          due_after: this.ledger_amount - alreadyPaidBefore - paidThisTime,
        },
        void_cancel: {
          amount: this.settlementChecks.void_cancel.amount,
          checked: !!this.settlementChecks.void_cancel.checked,
        },
        refund_to_patient: {
          amount: this.settlementChecks.refund_to_patient.amount,
          checked: !!this.settlementChecks.refund_to_patient.checked,
        },
        doctor_payment: {
          amount: this.settlementChecks.doctor_payment.amount,
          checked: !!this.settlementChecks.doctor_payment.checked,
        },
        cashback: {
          amount: this.settlementChecks.cashback.amount,
          checked: !!this.settlementChecks.cashback.checked,
        },
        payment_methods: this.paymentMethodChecks.map((pm) => ({
          method: pm.method,
          amount: pm.amount,
          checked: !!pm.checked,
        })),
      };
    },
    validateCollectForm() {
      this.collectFormError = null;
      this.paidAmountError = null;

      if (this.due_amount <= 0) {
        this.showValidationError('No due amount remaining for this user on selected date.');
        return false;
      }

      const paid = parseFloat(this.paymentDataSubmit.paid_amount);
      if (this.paymentDataSubmit.paid_amount === '' || this.paymentDataSubmit.paid_amount === null || isNaN(paid)) {
        this.showValidationError('Receive amount is required.', 'paid_amount');
        return false;
      }
      if (paid <= 0) {
        this.showValidationError('Receive amount must be greater than 0.', 'paid_amount');
        return false;
      }
      if (paid > this.due_amount) {
        this.showValidationError(
            'Receive amount cannot exceed due amount. Due: ' + this.formatAmount(this.due_amount) + ', Entered: ' + this.formatAmount(paid) + '.',
            'paid_amount'
        );
        return false;
      }

      return true;
    },
    initialize(date) {
      atshq
          .get("user-ledger?date=" + date)
          .then((response) => {
            this.desserts = response.data.users;
            this.total_ledger_amount = response.data.total_ledger_amount;
            this.total_paid_amount = response.data.total_paid_amount;
            this.total_due_amount = response.data.total_due_amount;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    user_ledger_new(item) {
      window.open(this.apiBaseUrl + "print/invoice-report-print?date=" + this.date + '&user_id=' + item.id + '&login_user_id=' + this.login_user_id);
    },
    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
    formatDateTime(value) {
      return moment(String(value)).format('DD MMM, YYYY hh:mm A');
    },
    parseCollectDetails(raw) {
      if (!raw) {
        return null;
      }
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return null;
        }
      }
      return raw;
    },
    openCollectDetailsModal(item) {
      this.selectedHistoryRow = item;
      this.parsedCollectDetails = this.parseCollectDetails(item.collect_details);
      this.collect_details_dialog = true;
    },
    userCollectAmountHistory(payment_by_user_id) {
      this.resetCollectForm();
      this.paymentDataSubmit.payment_by_user_id = payment_by_user_id;
      this.paymentDataSubmit.date = this.date;
      this.user_name = this.desserts.find(x => x.id == payment_by_user_id).full_name;
      atshq
          .get("get-user-income/" + payment_by_user_id + "?date=" + this.date)
          .then((response) => {
            const data = response.data;
            this.user_collect_histories = data.user_collect_histories || [];
            this.loadCollectBreakdown(data);
            this.add_user_collect_amount_history_dialog = true;
          })
          .catch((e) => {
            console.log(e);
            this.$noty.error(e.response.data.message || 'Failed to load collect amount data.');
          });
    },
    refreshUserInList(userId, data) {
      const idx = this.desserts.findIndex((u) => u.id == userId);
      if (idx !== -1) {
        this.$set(this.desserts[idx], 'paid_amount', data.alreadyPaidAmount);
        this.$set(this.desserts[idx], 'due_amount', data.due_amount);
        this.$set(this.desserts[idx], 'ledger_amount', data.ledger_amount);
      }
    },
    applyCollectBreakdownFromApi(data) {
      this.user_collect_histories = data.user_collect_histories || [];
      this.loadCollectBreakdown(data);
      this.refreshUserInList(this.paymentDataSubmit.payment_by_user_id, data);
    },
    user_payment_history_submit() {
      if (!this.validateCollectForm()) {
        return;
      }

      this.paymentDataSubmit.collect_details = this.buildCollectDetailsPayload();
      this.spinnerButtons = true;
      const userId = this.paymentDataSubmit.payment_by_user_id;
      const collectDate = this.paymentDataSubmit.date;
      atshq
          .post("user-collect-payment", this.paymentDataSubmit)
          .then((response) => {
            this.spinnerButtons = false;
            this.$noty.success(response.data.message || 'Paid Amount Successfully');
            this.paymentDataSubmit.paid_amount = '';
            this.paymentDataSubmit.note = '';
            return atshq.get("get-user-income/" + userId + "?date=" + collectDate);
          })
          .then((res) => {
            this.applyCollectBreakdownFromApi(res.data);
            this.initialize(collectDate);
          })
          .catch((e) => {
            const message = (e.response && e.response.data && e.response.data.message)
                ? e.response.data.message
                : 'Submit failed.';
            this.showValidationError(message);
            this.spinnerButtons = false;
          });
    },
  },
};
</script>
